"use client";
import { useState, useEffect } from "react";
import Header from "../components/Header";
import FixMenu from "../components/FixMenu";
import Announcement from "../components/Announcement";
const SunIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="4" />
    <path d="m12 2 0 2" />
    <path d="m12 20 0 2" />
    <path d="m4.93 4.93 1.41 1.41" />
    <path d="m17.66 17.66 1.41 1.41" />
    <path d="m2 12 2 0" />
    <path d="m20 12 2 0" />
    <path d="m6.34 17.66-1.41 1.41" />
    <path d="m19.07 4.93-1.41 1.41" />
  </svg>
);
const CalculatorIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect width="16" height="20" x="4" y="2" rx="2" />
    <line x1="8" x2="16" y1="6" y2="6" />
    <line x1="16" x2="16" y1="14" y2="18" />
    <path d="m16 10 4 4-4 4" />
  </svg>
);
const DollarSignIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" x2="12" y1="2" y2="22" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
  </svg>
);
const ZapIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2" />
  </svg>
);
const CalendarIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <rect width="18" height="18" x="3" y="4" rx="2" />
    <path d="M3 10h18" />
  </svg>
);
const LeafIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" />
  </svg>
);
const HomeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <polyline points="9,22 9,12 15,12 15,22" />
  </svg>
);
const styles = `
/* Reset and base styles */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
 
  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", sans-serif;
    line-height: 1.4;
  }
 
  /* Main container */
  .solar-calculator {
    min-height: 100vh;
    background: linear-gradient(135deg, #fef7ed 0%, #fefce8 50%, #f0fdf4 100%);
    padding: 0.5rem;
  }
 
  .container {
    max-width: 1280px;
    margin: 0 auto;
  }
 
  /* Header styles */
  .header {
    text-align: center;
    margin-bottom: 1rem;
  }
 
  .header-icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
  }
 
  .header-icon {
    padding: 0.5rem;
    background: linear-gradient(135deg, #f97316 0%, #eab308 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
 
  .header-icon svg {
    width: 1.5rem;
    height: 1.5rem;
    color: white;
  }
 
  .main-title {
    font-size: 1.75rem;
    font-weight: bold;
    background: linear-gradient(135deg, #ea580c 0%, #16a34a 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    margin: 0;
  }
 
  .subtitle {
    font-size: 0.875rem;
    color: #4b5563;
    max-width: 48rem;
    margin: 0 auto;
  }
 
  /* Grid layout */
  .main-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
  }
 
  @media (min-width: 1024px) {
    .main-grid {
      grid-template-columns: 1fr 1fr 1fr;
    }
 
    .main-title {
      font-size: 2rem;
    }
  }
 
  @media (min-width: 768px) {
    .main-title {
      font-size: 1.875rem;
    }
  }
 
  /* Card styles */
  .card {
    background: white;
    border-radius: 0.5rem;
    box-shadow: 0 15px 30px -8px rgba(0, 0, 0, 0.25);
    border: none;
    overflow: hidden;
  }
 
  .card-input {
    background: linear-gradient(135deg, #eff6ff 0%, #e0f2fe 100%);
  }
 
  .card-cost {
    background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
  }
 
  .card-savings {
    background: linear-gradient(135deg, #faf5ff 0%, #fdf2f8 100%);
  }
 
  /* Card header */
  .card-header {
    padding: 0.75rem;
    color: white;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }
 
  .card-header-input {
    background: linear-gradient(135deg, #2563eb 0%, #0891b2 100%);
  }
 
  .card-header-cost {
    background: linear-gradient(135deg, #16a34a 0%, #059669 100%);
  }
 
  .card-header-savings {
    background: linear-gradient(135deg, #9333ea 0%, #ec4899 100%);
  }
 
  .card-title {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
  }
 
  .card-title svg {
    width: 1rem;
    height: 1rem;
  }
 
  /* Card content */
  .card-content {
    padding: 0.75rem;
  }
 
  .input-space {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
 
  .input-group {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
 
  .input-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #374151;
  }
 
  .input-field {
    padding: 0.5rem;
    border: 1px solid #bfdbfe;
    border-radius: 0.25rem;
    text-align: center;
    font-weight: 600;
    font-size: 0.875rem;
    transition: border-color 0.2s;
  }
 
  .input-field:focus {
    outline: none;
    border-color: #3b82f6;
  }
 
  .input-field-green {
    border-color: #bbf7d0;
  }
 
  .input-field-green:focus {
    border-color: #22c55e;
  }
 
  .select-field {
    padding: 0.5rem;
    border: 1px solid #bfdbfe;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    background: white;
    transition: border-color 0.2s;
  }
 
  .select-field:focus {
    outline: none;
    border-color: #3b82f6;
  }
 
  /* Note box */
  .note-box {
    background: #fed7aa;
    border-left: 3px solid #f97316;
    padding: 0.5rem;
    border-radius: 0.25rem;
    margin-top: 0.25rem;
  }
 
  .note-text {
    font-size: 0.75rem;
    color: #c2410c;
  }
 
  /* Cost analysis items */
  .cost-space {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
 
  .cost-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    background: white;
    border-radius: 0.25rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    border-left: 3px solid;
  }
 
  .cost-item-blue {
    border-left-color: #3b82f6;
  }
 
  .cost-item-green {
    border-left-color: #22c55e;
  }
 
  .cost-item-purple {
    border-left-color: #a855f7;
  }
 
  .cost-label {
    font-weight: 600;
    color: #374151;
  }
 
  .cost-badge {
    font-size: 1.125rem;
    font-weight: bold;
    padding: 0.5rem 1rem;
    border-radius: 0.375rem;
  }
 
  .cost-badge-blue {
    background: #dbeafe;
    color: #1e40af;
  }
 
  .cost-badge-green {
    background: #dcfce7;
    color: #166534;
  }
 
  .cost-badge-purple {
    background: #f3e8ff;
    color: #7c2d12;
  }
 
  .separator {
    height: 1px;
    background: #e5e7eb;
    margin: 1rem 0;
  }
 
  .investment-highlight {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    background: linear-gradient(135deg, #fed7aa 0%, #fecaca 100%);
    border-radius: 0.5rem;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    border: 2px solid #fdba74;
  }
 
  .investment-label {
    font-weight: bold;
    color: #1f2937;
  }
 
  .investment-badge {
    font-size: 1.25rem;
    font-weight: bold;
    background: linear-gradient(135deg, #f97316 0%, #ef4444 100%);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 0.375rem;
  }
 
  /* Savings analysis */
  .savings-space {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
 
  .savings-item {
    background: white;
    padding: 0.5rem;
    border-radius: 0.25rem;
    text-align: center;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
 
  .savings-item-cyan {
    border-left: 3px solid #0891b2;
  }
 
  .savings-item-green {
    border-left: 3px solid #16a34a;
  }
 
  .savings-item-orange {
    border-left: 3px solid #ea580c;
  }
 
  .savings-item-emerald {
    border-left: 3px solid #059669;
  }
 
  .savings-value {
    font-size: 1rem;
    font-weight: 700;
    margin: 0;
  }
 
  .savings-label {
    font-size: 0.75rem;
    color: #4b5563;
    text-align: left;
  }
 
  .savings-icon-value {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin: 0;
  }
 
  .savings-icon-value svg {
    width: 1rem;
    height: 1rem;
  }
 
  /* Environmental impact */
  .environmental-card {
    background: white;
    border-radius: 0.5rem;
    padding: 0.75rem;
    margin-bottom: 1rem;
    margin: 7px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  }
 
  .environmental-content {
    padding: 2rem;
    text-align: center;
  }
 
  .environmental-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
 
  .environmental-icon {
    width: 3rem;
    height: 3rem;
    color: #16a34a;
  }
 
  .environmental-title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
  }
 
  .environmental-text {
    font-size: 0.75rem;
    color: #4b5563;
    margin: 0.25rem 0 0;
  }
 
  .environmental-highlight {
    font-weight: bold;
    font-size: 1.5rem;
    color: #166534;
  }
 
  /* Assumptions */
  .assumptions-card {
    background: white;
    border-radius: 0.5rem;
    padding: 0.75rem;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  }
 
  .assumptions-header {
    margin-bottom: 0.5rem;
  }
 
  .assumptions-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem;
  }
 
  .assumption-item {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-size: 0.75rem;
    color: #4b5563;
  }
 
  .assumption-dot {
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
  }
 
  .assumption-dot-blue {
    background: #3b82f6;
  }
 
  .assumption-dot-green {
    background: #22c55e;
  }
 
  .assumption-dot-orange {
    background: #f97316;
  }
 
  .assumption-dot-emerald {
    background: #10b981;
  }
 
  .assumption-text {
    color: #374151;
  }
 
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .solar-calculator {
      padding: 0.25rem;
    }
 
    .main-title {
      font-size: 1.5rem;
    }
 
    .subtitle {
      font-size: 0.75rem;
    }
 
    .environmental-header {
      flex-direction: column;
      text-align: center;
    }
 
    .environmental-icon {
      display: none;
    }
  }
`;
export default function SolarCalculator() {
  const [sanctionedLoad, setSanctionedLoad] = useState(2);
  const [shadowFreeArea, setShadowFreeArea] = useState("");
  const [natureOfConnection, setNatureOfConnection] = useState("Individual");
  const [suggestedSolarCapacity, setSuggestedSolarCapacity] = useState(null);
  const [recommendedSolarCapacity, setRecommendedSolarCapacity] = useState(0);
  const [costOfProject, setCostOfProject] = useState(0);
  const [centralGovtSubsidy, setCentralGovtSubsidy] = useState(0);
  const [stateGovtSubsidy, setStateGovtSubsidy] = useState(0);
  const [consumerInvestment, setConsumerInvestment] = useState(0);
  const [avgElectricityGeneration, setAvgElectricityGeneration] = useState(0);
  const [savingsInBill, setSavingsInBill] = useState(0);
  const [paybackPeriod, setPaybackPeriod] = useState(0);
  const [emissionSavings, setEmissionSavings] = useState(0);
  const [treesPlanted, setTreesPlanted] = useState(0);
  const costPerKw = 60000;
  const energyCharges = 5.5;
  const emissionFactor = 0.82;
  const kgCo2PerTree = 22;
  useEffect(() => {
    let calculatedRecommendedCapacity;
    const sanctionedLoadNum = Number.parseFloat(sanctionedLoad);
    const shadowFreeAreaNum = Number.parseFloat(shadowFreeArea);
    if (shadowFreeArea === "" || isNaN(shadowFreeAreaNum)) {
      calculatedRecommendedCapacity = sanctionedLoadNum;
    } else {
      const capacityFromArea = shadowFreeAreaNum / 100;
      calculatedRecommendedCapacity = Math.min(sanctionedLoadNum, capacityFromArea);
    }
    if (isNaN(calculatedRecommendedCapacity) || calculatedRecommendedCapacity < 0) {
      calculatedRecommendedCapacity = 0;
    }
    setRecommendedSolarCapacity(calculatedRecommendedCapacity);
    const capacityForCalculations = suggestedSolarCapacity !== null && !isNaN(suggestedSolarCapacity) ? Number.parseFloat(suggestedSolarCapacity) : calculatedRecommendedCapacity;
    const finalCapacity = Math.max(0, capacityForCalculations);
    const calculatedCostOfProject = finalCapacity * costPerKw;
    let calculatedCentralGovtSubsidy = 0;
    if (natureOfConnection === 'Individual') {
      calculatedCentralGovtSubsidy = Math.min(finalCapacity * 30000, 78000);
    } else {
      calculatedCentralGovtSubsidy = Math.min(finalCapacity * 18000, 9000000);
    }
    let calculatedStateGovtSubsidy = 0;
    if (natureOfConnection === 'Individual') {
      calculatedStateGovtSubsidy = Math.min(finalCapacity * 15000, 30000);
    } else {
      calculatedStateGovtSubsidy = 0;
    }
    const calculatedConsumerInvestment = calculatedCostOfProject - calculatedCentralGovtSubsidy - calculatedStateGovtSubsidy;
   
    const calculatedAvgElectricityGeneration = Math.round(finalCapacity * 4 * 365 / 12);
    const calculatedSavingsInBill = Math.round(calculatedAvgElectricityGeneration * energyCharges);
   
    const annualSavings = calculatedSavingsInBill * 12;
    const annualInterestRate = 0.0391; // 3.91%
    let calculatedPaybackPeriod = 0;
    const numerator = annualSavings;
    const denominator = annualSavings - (annualInterestRate * calculatedConsumerInvestment);
    if (denominator > 0 && numerator > 0) {
      const logValue = numerator / denominator;
      const logBase = 1 + annualInterestRate;
     
      if (logValue > 0 && logBase > 0 && logBase !== 1) {
        const yearsToPayback = Math.log(logValue) / Math.log(logBase);
        calculatedPaybackPeriod = yearsToPayback;
      } else {
        calculatedPaybackPeriod = Infinity;
      }
    } else if (calculatedConsumerInvestment === 0 && annualSavings >= 0) {
      calculatedPaybackPeriod = 0;
    } else {
      calculatedPaybackPeriod = Infinity;
    }
    if (isFinite(calculatedPaybackPeriod)) {
      setPaybackPeriod(parseFloat(calculatedPaybackPeriod.toFixed(2)));
    } else if (calculatedConsumerInvestment > 0) {
      setPaybackPeriod(Infinity);
    } else {
      setPaybackPeriod(0);
    }
    const monthlyGeneration = calculatedAvgElectricityGeneration;
    const annualGenerationWithoutDegradation = monthlyGeneration * 12;
    const degradationFactor = 0.95;
    const numberOfYears = 25;
    const emissionFactorKgPerKwh = emissionFactor;
    const totalGeneration25YearsKwh = annualGenerationWithoutDegradation * (1 - Math.pow(degradationFactor, numberOfYears)) / (1 - degradationFactor);
    const totalEmissionReductionKg = totalGeneration25YearsKwh * emissionFactorKgPerKwh;
    const totalEmissionReductionTonne = totalEmissionReductionKg / 1000;
    const calculatedTreesPlanted = Math.round(totalEmissionReductionTonne * 1000 / kgCo2PerTree);
    setCostOfProject(calculatedCostOfProject);
    setCentralGovtSubsidy(calculatedCentralGovtSubsidy);
    setStateGovtSubsidy(calculatedStateGovtSubsidy);
    setConsumerInvestment(calculatedConsumerInvestment);
    setAvgElectricityGeneration(calculatedAvgElectricityGeneration);
    setSavingsInBill(calculatedSavingsInBill);
    setEmissionSavings(totalEmissionReductionTonne);
    setTreesPlanted(calculatedTreesPlanted);
  }, [
    sanctionedLoad,
    shadowFreeArea,
    natureOfConnection,
    suggestedSolarCapacity,
    costPerKw,
    energyCharges,
    emissionFactor,
    kgCo2PerTree
  ]);
  const handleSuggestedCapacityChange = (e) => {
    const value = e.target.value;
    setSuggestedSolarCapacity(value === '' ? null : Number.parseFloat(value));
  };
  return (
    <div id="bodyaddid">
      <style>{styles}</style>
      <Header />
      <FixMenu />
      <section className="main-banner">
        <div
          className="innerpagebanner"
          style={{
            backgroundImage: "url(" + "assets/img/inner/about-banner.png" + ")",
            backgroundSize: "100% auto",
          }}
        ></div>
        <div className="innerpagebannerCompanyProfile"></div>
        <Announcement />
      </section>
      <section className="main_sectiods">
        <div className="container main_bdy">
          <div className="row">
            <div className="col-lg-12 brdcum_designs">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="https://www.noidapower.com/">Home</a>
                  <span className="icondsds">
                    <i className="fa fa-chevron-right" aria-hidden="true"></i>
                  </span>
                </li>
                <li className="breadcrumb-item">
                  <a href="/" className="active">
                    Roof-Top Solar
                  </a>
                </li>
              </ol>
            </div>
          </div>
          <div className="row justify-content-center padtops pt-3">
            <div className="col-sm-12 bg_cols">
              <div className="solar-calculator">
                <div className="container">
                  <div className="header">
                    <div className="header-icon-container">
                      <div className="header-icon">
                        <SunIcon />
                      </div>
                      <h1 className="main-title">Solar PV Calculator</h1>
                    </div>
                    <p className="subtitle">
                      Roof-Top Solar PV Calculator for Residential Consumers
                      under PM Surya Ghar
                    </p>
                  </div>
                  <div className="main-grid">
                    <div className="card card-input">
                      <div className="card-header card-header-input">
                        <h2 className="card-title">
                          <CalculatorIcon />
                          Enter the following details
                        </h2>
                      </div>
                      <div className="card-content">
                        <div className="input-space">
                          <div className="input-group">
                            <label
                              htmlFor="sanctioned-load"
                              className="input-label"
                            >
                              Sanctioned Load (kW) *
                            </label>
                            <input
                              id="sanctioned-load"
                              type="number"
                              value={sanctionedLoad}
                              onChange={(e) =>
                                setSanctionedLoad(
                                  Number.parseFloat(e.target.value)
                                )
                              }
                              className="input-field"
                            />
                          </div>
                          <div className="input-group">
                            <label
                              htmlFor="shadow-area"
                              className="input-label"
                            >
                              Shadow Free Area (Sq.feet)
                            </label>
                            <input
                              id="shadow-area"
                              type="number"
                              value={shadowFreeArea}
                              onChange={(e) =>
                                setShadowFreeArea(e.target.value)
                              }
                              className="input-field"
                            />
                          </div>
                          <div className="input-group">
                            <label
                              htmlFor="connection-type"
                              className="input-label"
                            >
                              Nature of Domestic Connection *
                            </label>
                            <select
                              value={natureOfConnection}
                              onChange={(e) =>
                                setNatureOfConnection(e.target.value)
                              }
                              className="select-field"
                            >
                              <option value="Individual">Individual</option>
                              <option value="RWA-Common facilities">
                                RWA-Common facilities
                              </option>
                            </select>
                          </div>
                          <div className="input-group">
                            <label
                              htmlFor="solar-capacity"
                              className="input-label"
                            >
                              Suggested Solar Capacity (kW)
                            </label>
                            <input
                              id="solar-capacity"
                              type="number"
                              readOnly
                              value={suggestedSolarCapacity !== null && !isNaN(suggestedSolarCapacity) ? suggestedSolarCapacity : recommendedSolarCapacity.toFixed(2)}
                              onChange={handleSuggestedCapacityChange}
                              className="input-field"
                            />
                            {shadowFreeArea === "" && (
                              <div className="note-box">
                                <p className="note-text">
                                  <strong>Note:</strong> Based on your inputs, a {recommendedSolarCapacity.toFixed(2)}kW installation is recommended.
                                </p>
                              </div>
                            )}
                            {natureOfConnection === "RWA-Common facilities" && (
                              <div className="note-box" style={{ marginTop: "0.5rem" }}>
                                <p className="note-text">
                                  <strong>Note:</strong> For RWA Central Subsidy is allowed for only common facilities load, including EV charging, up to 500 kW Capacity only not for total sanctioned load of the society
                                </p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card card-cost">
                      <div className="card-header card-header-cost">
                        <h2 className="card-title">
                          ₹ Indicative cost of Installation (INR)
                        </h2>
                      </div>
                      <div className="card-content">
                        <div className="cost-space">
                          <div className="cost-item cost-item-blue">
                            <span className="cost-label">Project Cost</span>
                            <span className="cost-badge cost-badge-blue">
                              ₹{costOfProject.toLocaleString()}
                            </span>
                          </div>
                          <div className="cost-item cost-item-green">
                            <span className="cost-label">
                              Central Govt. Subsidy
                            </span>
                            <span className="cost-badge cost-badge-green">
                              ₹{centralGovtSubsidy.toLocaleString()}
                            </span>
                          </div>
                          <div className="cost-item cost-item-purple">
                            <span className="cost-label">
                              State Govt. Subsidy
                            </span>
                            <span className="cost-badge cost-badge-purple">
                              ₹{stateGovtSubsidy.toLocaleString()}
                            </span>
                          </div>
                          <div className="separator"></div>
                          <div className="investment-highlight">
                            <span className="investment-label">
                            Approximate Consumer Investment
                            </span>
                            <span className="investment-badge">
                              ₹{consumerInvestment.toLocaleString()}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Savings Analysis */}
                    <div className="card card-savings">
                      <div className="card-header card-header-savings">
                        <h2 className="card-title">
                          <ZapIcon />
                          Expected Savings to Consumers
                        </h2>
                      </div>
                      <div className="card-content">
                        <div className="savings-space">
                          <div className="savings-item savings-item-cyan">
                            <div className="savings-value savings-value-cyan">
                              {avgElectricityGeneration.toFixed(0)}
                            </div>
                            <div className="savings-label">
                            Average Electricity Generation / Month (kWh)
                            </div>
                          </div>
                          <div className="savings-item savings-item-green">
                            <div className="savings-value savings-value-green">
                              ₹{savingsInBill.toLocaleString()}
                            </div>
                            <div className="savings-label">
                            Savings Electricity bill / Month (INR)
                            </div>
                          </div>
                          <div className="savings-item savings-item-orange">
                            <div className="savings-icon-value">
                              <CalendarIcon />
                              <span className="savings-value savings-value-orange">
                                {paybackPeriod === 0 ? 'N/A' : paybackPeriod.toFixed(1)}
                              </span>
                            </div>
                            <div className="savings-label">
                            Approximate Payback Period (Years)
                            </div>
                          </div>
                          <div className="savings-item savings-item-emerald">
                            <div className="savings-icon-value">
                              <LeafIcon />
                              <span className="savings-value savings-value-emerald">
                                {emissionSavings.toFixed(0)}
                              </span>
                            </div>
                            <div className="savings-label">
                            Emission Savings CO2 tonne for 25 Years
                            </div>
                          </div>
                        </div>
                      </div>
                       <div className="environmental-card">
                    <div className="environmental-content">
                      <div>
                        <h3 className="environmental-title">
                          Environmental Impact
                        </h3>
                        <p className="environmental-text">
                          The reduction in emissions of{" "}
                          <span className="environmental-highlight">
                            {emissionSavings.toFixed(0)} tonnes
                          </span>{" "}
                          is equivalent to planting{" "}
                          <span className="environmental-highlight">
                            {treesPlanted.toFixed(0)} matured trees
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                    </div>
                  </div>
                 
                 
                  {/* Assumptions */}
                  <div className="assumptions-card">
                    <div className="assumptions-header">
                      <h2 className="card-title">
                        <HomeIcon />
                        Calculation Assumptions
                      </h2>
                    </div>
                    <div className="assumptions-content">
                      <div className="assumptions-grid">
                        <div className="assumption-item">
                          <div className="assumption-dot assumption-dot-blue"></div>
                          <span className="assumption-text">
                            Tentative cost of solar panel - ₹
                            {costPerKw.toLocaleString()}/kW
                          </span>
                        </div>
                        <div className="assumption-item">
                          <div className="assumption-dot assumption-dot-green"></div>
                          <span className="assumption-text">
                            Energy Charges - ₹{energyCharges}/kWh
                          </span>
                        </div>
                        <div className="assumption-item">
                          <div className="assumption-dot assumption-dot-orange"></div>
                          <span className="assumption-text">
                            Emission factor - {emissionFactor}kg/kWh
                          </span>
                        </div>
                        <div className="assumption-item">
                          <div className="assumption-dot assumption-dot-emerald"></div>
                          <span className="assumption-text">
                            1 matured tree absorbs approx {kgCo2PerTree} kg of
                            CO₂/annum
                          </span>
                        </div>
                        <div className="assumption-item">
                          <div className="assumption-dot assumption-dot-blue"></div>
                          <span className="assumption-text">
                            Tentative Shadow free area required - 1kW/100Sqft
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}



